<script setup lang="ts">

import { faArrowUpFromBracket } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useTutorBillingExportMenu } from '../model/tutor-billing-export-menu.hook'

defineOptions({
  name: 'TutorBillingExportMenu',
})

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  items,
  setToggle,
  setSelect,
} = useTutorBillingExportMenu()
</script>

<template>
  <div
    ref="containerRef"
    class="tutor-billing-export-menu"
  >
    <BtnIcon
      :icon="faArrowUpFromBracket"
      tooltip-text="Export"
      @click="setToggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="tutor-billing-export-menu__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          v-for="item in items"
          :key="item.value"
          :text="item.text"
          color="blue"
          @click="setSelect(item.value)"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TutorBillingExportMenu.scss" />
